// import ModalForm from "./Form";
import StudyInformationTableForm from "./StudyInformationTableForm";
import {
	STUDY_INFORMATION,
	DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const StudyInformationTableSchema = {
	components: { StudyInformationTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: STUDY_INFORMATION + "?invoice_id=" + this.invoiceRequestId,
			tableId: "study-information-table",
			formId: "study-information-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Class Name",
					type: "custom-html",
					key: "course_id",
					modifier: (value) => {
						return value.course_name;
					},
				},
				{
					title: "Product Name",
					type: "custom-html",
					key: "product_id",
					modifier: (value) => {
						return value.name;
					},
				},
                {
					title: "Mon",
					type: "custom-html",
					key: "schedule_recommendation_id",
					modifier: (value) => {
						return value.time_1
					}
				},
                {
					title: "Tue",
					type: "custom-html",
					key: "schedule_recommendation_id",
					modifier: (value) => {
						return value.time_2
					}
				},
                {
					title: "Wed",
					type: "custom-html",
					key: "schedule_recommendation_id",
					modifier: (value) => {
						return value.time_3
					}
				},
                {
					title: "Thu",
					type: "custom-html",
					key: "schedule_recommendation_id",
					modifier: (value) => {
						return value.time_4
					}
				},
                {
					title: "Fri",
					type: "custom-html",
					key: "schedule_recommendation_id",
					modifier: (value) => {
						return value.time_5
					}
				},
                {
					title: "Sat",
					type: "custom-html",
					key: "schedule_recommendation_id",
					modifier: (value) => {
						return value.time_6
					}
				},
				{
					title: "Sun",
					type: "custom-html",
					key: "schedule_recommendation_id",
					modifier: (value) => {
						return value.time_7
					}
				},
                {
					title: "Start Date",
					type: "custom-html",
					key: "course_id",
					modifier: (value) => {
						return value.course_date_start;
					},
				},
				{
					title: "CLC Date",
					type: "custom-html",
					key: "course_id",
					modifier: (value) => {
						return value.course_date_clc_start;
					},
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "StudyInformationTable",
				url: STUDY_INFORMATION + "?invoice_id=" + this.invoiceRequestId,
				showHeader: true,
				enableHighlights: false,
				enableSaveFilter: false,
				enableRowSelect: false,
				columns: [],
				actions: [
                    {
                        title: this.$t("view"),
                        icon: "eye",
                        type: "none",
                        // component: "app-add-modal",
                        component: "study-information-table-form",
                        modalId: "study-information-table-form",
                    },
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						// component: "app-add-modal",
						component: "study-information-table-form",
						modalId: "study-information-table-form",
					},
				],
				showFilter: false,
				showSearch: false,
				showCount: false,
				showClearFilter: false,
				paginationType: "false",
				responsive: true,
				rowLimit: 5,
				showAction: false,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {},
};
